import UtilityBar from "./UtilityBar";
import { Outlet } from "react-router-dom";


export default function ExamsProLayout() {
    return (
        <div className="min-h-screen flex flex-col bg-gray-50 text-gray-900">
            {/* 🔹 Shared ExamsPro utility navigation (return, logins, support) */}
            <UtilityBar />

            {/* 🔹 Main content */}
            <main className="flex-1">
                <Outlet />
            </main>

        </div>
    );
}